import { render } from "./CreateMnemonic.vue?vue&type=template&id=09118834&scoped=true"
import script from "./CreateMnemonic.vue?vue&type=script&lang=ts"
export * from "./CreateMnemonic.vue?vue&type=script&lang=ts"

import "./CreateMnemonic.vue?vue&type=style&index=0&id=09118834&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09118834"

export default script